
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3d56a71d!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./minimumordercoinrollspanel.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./minimumordercoinrollspanel.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3d56a71d!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./minimumordercoinrollspanel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/dq-ui/packages/minimumordercoinrollspanel/src/minimumordercoinrollspanel.vue
// module id = 473
// module chunks = 36